import Cookies from "js-cookie";
import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { GlobalProvider } from "../context/GlobalContext";
import Dashboard from "../pages/Dashboard";
import DetailKerja from "../pages/DetailKerja";
import FormData from "../pages/FormData";
import GantiPass from "../pages/GantiPass";
import LandingPage from "../pages/LandingPage";
import ListData from "../pages/ListData";
import Login from "../pages/Login";
import Lowongan from "../pages/Lowongan";
import Profile from "../pages/Profile";
import Register from "../pages/Register";
import LayoutDashboard from "../widget/LayoutDashboard";
import LayoutPublik from "../widget/LayoutPublik";

const Routing = () => {
  const LoginRoute = (props) => {
    if (Cookies.get("token") === undefined) {
      return props.children;
    } else if (Cookies.get("token") !== undefined) {
      return <Navigate to={"/dashboard"} />;
    }
  };

  const DashboardRoute = (props) => {
    if (Cookies.get("token") !== undefined) {
      return props.children;
    } else if (Cookies.get("token") === undefined) {
      return <Navigate to={"/login"} />;
    }
  };
  return (
    <BrowserRouter>
      <GlobalProvider>
        <Routes>
          {/* Route Autentikasi */}
          <Route
            path="/register"
            element={
              <LoginRoute>
                <Register />
              </LoginRoute>
            }
          />
          <Route
            path="/login"
            element={
              <LoginRoute>
                <Login />
              </LoginRoute>
            }
          />
          {/* Route Publik */}
          <Route
            path="/"
            element={
              <LayoutPublik>
                <LandingPage />
              </LayoutPublik>
            }
          />
          <Route
            path="/job-vacancy"
            element={
              <LayoutPublik>
                <Lowongan />
              </LayoutPublik>
            }
          />
          <Route
            path="/job-vacancy/:Id"
            element={
              <LayoutPublik>
                <DetailKerja />
              </LayoutPublik>
            }
          />
          {/* Route Dashboard */}
          <Route
            path="/dashboard"
            element={
              <DashboardRoute>
                <LayoutDashboard>
                  <Dashboard />
                </LayoutDashboard>
              </DashboardRoute>
            }
          />
          <Route
            path="/dashboard/profile"
            element={
              <DashboardRoute>
                <LayoutDashboard>
                  <Profile />
                </LayoutDashboard>
              </DashboardRoute>
            }
          />
          <Route
            path="/dashboard/change-password"
            element={
              <DashboardRoute>
                <LayoutDashboard>
                  <GantiPass />
                </LayoutDashboard>
              </DashboardRoute>
            }
          />
          <Route
            path="/dashboard/list-job-vacancy"
            element={
              <DashboardRoute>
                <LayoutDashboard>
                  <ListData />
                </LayoutDashboard>
              </DashboardRoute>
            }
          />
          <Route
            path="/dashboard/list-job-vacancy/form"
            element={
              <DashboardRoute>
                <LayoutDashboard>
                  <FormData />
                </LayoutDashboard>
              </DashboardRoute>
            }
          />
          <Route
            path="/dashboard/list-job-vacancy/:IdData"
            element={
              <DashboardRoute>
                <LayoutDashboard>
                  <FormData />
                </LayoutDashboard>
              </DashboardRoute>
            }
          />
        </Routes>
      </GlobalProvider>
    </BrowserRouter>
  );
};

export default Routing;
